<template>
  <div>
    <b-container fluid>
      <h3 class="mt-3">Fulfillment Process</h3>
      <iframe :src="pdf_to_print" id="myFrame-fulfil" frameborder="0" style="display: none" width="300" height="300">
      </iframe>

      <hr />

      <b-card class="mb-1">
        <div style="width: 90%">
          <!-- <b-row nogutter>
          <b-col cols="1">
            <strong>Mode</strong>
          </b-col>
          <b-col>
            <b-form-group class="mb-0">
              <b-form-radio-group
                v-model="process_mode"
                :options="process_mode_options"
                name="radio-inline"
                size="sm"
              ></b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row> -->
          <b-row>
            <b-col cols="2">
              <strong>Tracking #</strong>
            </b-col>
            <b-col cols="3">
              <b-form-input ref="txt_order_number" size="sm" type="text" placeholder
                v-model="order_master_search.order_number" v-on:keyup.enter="searchOrder()" autocomplete="off"
  autocorrect="off"
  autocapitalize="off"
  spellcheck="false" data-lpignore="true" data-form-type="other"></b-form-input>
            </b-col>

            <b-col>
              <b-form-checkbox :disabled="!disable_form" id="checkbox-packed_by_vendor"
                v-model="fulfil_obj.packed_by_vendor" name="checkbox-packed_by_vendor" value="1"
                :unchecked-value="null">
                Packed by Vendor
              </b-form-checkbox>
            </b-col>
            <b-col>
              <b-form-checkbox :disabled="!disable_form" id="checkbox-remark_input_mode"
                v-model="fulfil_obj.remark_input_mode" name="checkbox-remark_input_mode" value="1"
                :unchecked-value="null">
                Remark Input Mode
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-row class="mt-2">
            <b-col class="col-2">
              <strong>Courier:</strong>
            </b-col>
            <b-col class="col-2">
              <span v-if="tracking_obj">{{
                tracking_obj.courier_short_name
              }}</span>
              <span v-if="!order_master">-</span>
            </b-col>

            <b-col class="col-2">
              <strong>Client:</strong>
            </b-col>
            <b-col class="col-2">
              <span v-if="tracking_obj">{{ tracking_obj.client_name }}</span>
              <span v-if="!order_master">-</span>
            </b-col>
          </b-row>
          <hr />
          <!-- </b-card>
      <b-card class="mt-1"> -->
          <div v-if="fulfil_obj.packed_by_vendor == null">
            <b-row class="mt-2">
              <!-- <b-col cols="2" class="pr-1">
                <strong></strong>
              </b-col> -->
              <b-col cols="1" class="pr-1"> </b-col>

              <b-col cols="3" class="pl-0 pr-1">
                <strong>Product SKU</strong>
              </b-col>

              <b-col cols="1" class="pl-0 pr-1">
                <strong>Quantity</strong>
              </b-col>

              <b-col cols="3" class="pl-0 pr-1">
                <strong>Description</strong>
              </b-col>

              <b-col cols="2" class="pl-0 pr-1">
                <strong>Lot#</strong>
              </b-col>

              <b-col class="pl-0 pr-1">
                <strong>Remark</strong>
              </b-col>
            </b-row>

            <b-row class="mt-2" :key="row_product_i" v-for="(row_product, row_product_i) in fulfil_products">
              <b-col cols="1" class="pr-1">
                <b-button class="btn-block" style="height: 100%" :variant="row_product.inputType === 'Barcode' || row_product.photo
                  ? 'success'
                  : 'warning'
                  " size="lg" @click="onOpenTakePhotoModal(row_product_i)"></b-button>
              </b-col>

              <b-col cols="3" class="pl-0 pr-1">
                <b-form-input size="sm" :ref="'txt_product_sku_' + row_product_i"
                  :id="'txt_product_sku_' + row_product_i" type="text" placeholder="Product SKU"
                  :disabled="disable_form" v-model="row_product.product_sku"
                  v-on:keyup.enter="validateRowInfo(row_product, row_product_i)"
                  @keydown="onKeyDown($event, row_product_i)"
                  :state="checkProductRowSKUState(row_product)"
                  autocomplete="off"
  autocorrect="off"
  autocapitalize="off"
  spellcheck="false" data-lpignore="true" data-form-type="other"></b-form-input>
              </b-col>

              <!-- @keydown="onKeyDown($event, row_product_i)" -->

              <b-col cols="1" class="pl-0 pr-1">
                <b-form-input :ref="'txt_quantity_' + row_product_i" size="sm" :id="'txt_quantity_' + row_product_i"
                  type="text" placeholder="Quantity" v-model="row_product.product_qty"
                  :readonly="!row_product.unlock_qty" @change="checkProductCnt()"
                  @click="unlockQtyInput(row_product, row_product_i)"
                  :state="checkProductRowQtyState(row_product, row_product_i)"></b-form-input>
              </b-col>

              <b-col cols="3" class="pl-0 pr-1">
                <b-form-input size="sm" :id="'txt_description_' + row_product_i" type="text" placeholder="Description"
                  v-model="row_product.product_description" disabled></b-form-input>
              </b-col>

              <b-col cols="2" class="pl-0 pr-1">
                <div class="div-commit_lot-container">
                  <div class="div-commit_lot valid_lot" :key="product_commit_record_i"
                    v-for="(product_commit_record, product_commit_record_i) in row_product.commit_records">
                    {{ product_commit_record.lot_number }}</div>
                </div>
              </b-col>

              <b-col class="pl-0 pr-1">

                <b-form-input size="sm" :ref="'txt_remark_' + row_product_i" :id="'txt_remark_' + row_product_i"
                  type="text" placeholder="Remark" v-model="row_product.product_remark"
                  :disabled="disable_form || fulfil_obj.remark_input_mode != '1'"
                  v-on:keyup.enter="onKeyDownRemark(row_product, row_product_i)"
                  :state="checkProductRowRemarkState(row_product, row_product_i)"></b-form-input>
              </b-col>
            </b-row>
          </div>

          <div v-if="fulfil_obj.packed_by_vendor != null">
            <b-row class="mt-2" :key="row_order_i" v-for="(row_order, row_order_i) in fulfil_orders">
              <b-col cols="3" class="pr-1">
                <b-form-input size="sm" :ref="'txt_order_number_' + row_order_i" :id="'txt_order_number_' + row_order_i"
                  type="text" placeholder="Order #" v-model="row_order.order_number"
                  v-on:keyup.enter="validateRowInfo(row_order, row_order_i)"
                  :state="checkOrderRowState(row_order, row_order_i)"></b-form-input>
              </b-col>

              <b-col cols="3" class="pr-1">
                <b-form-input size="sm" :ref="'txt_order_cartons_' + row_order_i"
                  :id="'txt_order_cartons_' + row_order_i" type="text" placeholder="Cartons"
                  v-model="row_order.order_cartons"></b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>

        <b-button class="mt-2 btn-action" variant="info" size="sm" :disabled="disable_form"
          @click="showRemainingItems()">Show Remaining Items</b-button>

        <b-button v-if="false" class="mt-2 btn-action" variant="info" size="sm" style="float: right;"
          :disabled="disablePause()" @click="pauseFulfilment()">Pause Fulfilment</b-button>
      </b-card>

      <b-card class="mt-1 mb-1">
        <b-row class="mb-3" v-if="fulfil_obj.packed_by_vendor == null">
          <b-col cols="2">
            <strong>Item Count</strong>
          </b-col>
          <b-col cols="1" class="center_align">{{
            fulfil_obj.actual_total_item_qty || "-"
          }}</b-col>
          <b-col cols="1">
            <div class="dot_container">
              <div v-if="!isItemCountValid()" class="dot_red"></div>
              <div v-if="isItemCountValid()" class="dot_green"></div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="2">
            <strong>Total Weight (kg)</strong>
          </b-col>
          <b-col cols="1"><b-form-input :ref="'txt_actual_total_weight'" class="center_align" size="sm" type="text"
              placeholder :disabled="disable_form" v-model="fulfil_obj.actual_total_weight"></b-form-input></b-col>
          <b-col cols="1">
            <div class="dot_container">
              <div v-if="!checkTotalWeight()" class="dot_red"></div>
              <div v-if="checkTotalWeight()" class="dot_green"></div>
            </div>
          </b-col>
        </b-row>

        <b-row class="mb-2">
          <b-col cols="2">
            <strong>Total Size (cm)</strong>
          </b-col>
          <b-col cols="1"><b-form-input class="center_align" size="sm" type="text" placeholder="Height"
              :disabled="disable_form" v-model="fulfil_obj.actual_size_height"></b-form-input></b-col>
          <b-col cols="1"><b-form-input class="center_align" size="sm" type="text" placeholder="Width"
              :disabled="disable_form" v-model="fulfil_obj.actual_size_width"></b-form-input></b-col>
          <b-col cols="1"><b-form-input class="center_align" size="sm" type="text" placeholder="Depth"
              :disabled="disable_form" v-model="fulfil_obj.actual_size_depth"></b-form-input></b-col>
        </b-row>

        <b-row>
          <b-col cols="2">
            <strong>No. of Cartons</strong>
          </b-col>
          <b-col cols="1"><b-form-input class="center_align" size="sm" type="text" placeholder
              :disabled="disable_form || lockCtns" v-model="fulfil_obj.no_of_cartons"></b-form-input></b-col>
          <b-col cols="1">
            <div class="dot_container">
              <div v-if="!checkTotalCtns()" class="dot_red"></div>
              <div v-if="checkTotalCtns()" class="dot_green"></div>
            </div>
          </b-col>
        </b-row>

        <b-button class="mt-2 btn-action btn-block" variant="info" size="lg" :disabled="canPrintWaybill()"
          @click="printWaybill()">Print Waybill</b-button>
      </b-card>

      <b-modal ref="modal_confirmFulfill" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Are you sure to fulfill this order?</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="hideModal_confirmFulfill">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="updateFulfillStatus()">Confirm</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_takePhoto" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>
              <web-cam ref="webcam" :device-id="deviceId" width="100%" @cameras="onCameras"
                @camera-change="onCameraChange" />
            </b-col>

            <b-col>
              <b-select v-model="camera">
                <option>-- Select Device --</option>
                <option v-for="device in devices" :key="device.deviceId" :value="device.deviceId">
                  {{ device.label }}
                </option>
              </b-select>
            </b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn class="mt-3" variant="outline-danger" @click="onCancelTakePhoto()">Cancel</b-btn>
          <b-btn class="mt-3" variant="outline-success" @click="onTakePhoto()">Take Photo</b-btn>
        </div>
      </b-modal>

      <b-modal ref="modal_showRemainingItems" centered hide-footer hide-header size="lg"
        modal-class="remaining-items-modal" content-class="remaining-items-modal-content">
        <div class="remaining-items-wrapper">
          <div class="remaining-items-header">
            <div>
              <div class="remaining-items-title">Remaining Items</div>
              <div class="remaining-items-subtitle" v-if="not_fulfiled_items && not_fulfiled_items.length > 0">
                {{ not_fulfiled_items.length }} item(s) not yet fulfilled
              </div>
            </div>
          </div>

          <div v-if="not_fulfiled_items && not_fulfiled_items.length > 0" class="remaining-items-list">
            <div class="remaining-item-card" v-for="(not_fulfiled_item, nfii) in not_fulfiled_items"
              :key="`${not_fulfiled_item.product_sku}-${nfii}`">
              <div class="remaining-item-left">
                <div class="remaining-item-index">#{{ nfii + 1 }}</div>
                <div class="remaining-item-desc">
                  {{ not_fulfiled_item.product_description || "-" }}
                </div>
                <div class="remaining-item-sku">
                  SKU: {{ maskSku(not_fulfiled_item.product_sku) }}
                </div>
              </div>

              <div class="remaining-item-right">
                <div class="remaining-item-qty-label">Remaining</div>
                <div class="remaining-item-qty">
                  {{ not_fulfiled_item.remaining_qty }}
                </div>
              </div>
            </div>
          </div>

          <div v-else class="remaining-items-empty">
            <div class="remaining-items-empty-title">No remaining items</div>
            <div class="remaining-items-empty-subtitle">
              All committed items are fulfilled.
            </div>
          </div>
        </div>

        <div class="text-right mt-3">
          <b-btn variant="success" @click="hideModal_showRemainingItems">OK</b-btn>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import printJS from "print-js";
import { WebCam } from "vue-web-cam";

const product_fields = [
  {
    key: "product_sku",
    label: "Product SKU",
  },
  {
    key: "product_qty",
    label: "Quantity",
  },
  {
    key: "product_description",
    label: "Product Description",
  },
];

export default {
  name: "OrderMasterDetail",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
  components: {
    barcode: VueBarcode,
    WebCam,
  },
  data() {
    return {
      lockCtns: false,
      disable_form: true,
      pdf_to_print: false,
      order_master: false,
      updating_item: false,
      camera: null,
      deviceId: null,
      devices: [],
      fulfil_product_index: null,

      breadcrumb_items: [
        {
          text: "Order Master",
          to: { name: "Order Master" },
        },
        {
          text: "Detail",
          active: true,
        },
      ],
      process_mode_options: [
        {
          text: "Simple",
          value: "simple",
        },
        {
          text: "Advanced",
          value: "advanced",
        },
      ],
      process_mode: "advanced",
      order_master_search: {},
      loader: false,
      order_master_products: [],
      fulfil_products: [{}],
      product_fields: product_fields,
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      total_item_qty: 0,
      fulfil_obj: {
        total_item_qty: 0,
        total_weight: 0,
        no_of_cartons: 1,
        actual_total_weight: null,
        packed_by_vendor: null,
        actual_size_height: null,
        actual_size_width: null,
        actual_size_depth: null,
        remark_input_mode: null
      },
      tracking_obj: {},
      fulfil_orders: [
        {
          order_cartons: 1,
        },
      ],
      not_fulfiled_items: [],
      product_serial: [],
    };
  },
  async created() {
    // await this.getOrderMasterDetail();
    // await this.getOrderMasterProduct();
    this.initialized = true;
    if (
      this.$store.state.user_obj.client_id == "20" ||
      this.$store.state.user_obj.client_id == "23" ||
      this.$store.state.user_obj.client_id == "50"
    ) {
      this.fulfil_obj.packed_by_vendor = 1;
    }
  },
  mounted() {
    // this.loader = this.$loading.show({
    //   isFullPage: true,
    //   canCancel: false
    // });
  },
  watch: {
    camera: function (id) {
      this.deviceId = id;
    },
    devices: function () {
      // Once we have a list select the first one
      const [first, ...tail] = this.devices;
      if (first) {
        this.camera = first.deviceId;
        this.deviceId = first.deviceId;
      }
    },
  },
  methods: {
    displayDate(d) {
      if (d) {
        return moment(d).format("YYYY-MM-DD");
      } else {
        return "/";
      }
    },

    async getFulfilmentProcessInfo() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "fulfilment_process_info_get.php",
        data: {
          tracking_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      if (response.data.tracking.status == "cancel") {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Tracking Cancelled 此追蹤單號已取消",
        });
        return;
      }

      if (response.data.tracking.status == "Hold") {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "HOLD order 正在暫停處理",
        });
        return;
      }

      if (
        !response.data.tracking.orders ||
        response.data.tracking.orders.length == 0
      ) {
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Tracking Number 無法找到對應的追蹤單號",
        });
        return;
      }

      for (let i in response.data.tracking.orders) {
        if (
          !response.data.tracking.orders[i] ||
          response.data.tracking.orders[i].tracking_number == ""
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Invalid Tracking Number 訂單追蹤單號無效",
          });
          return;
        }

        if (
          !this.fulfil_obj.packed_by_vendor &&
          response.data.tracking.orders[i].stock_status != "committed"
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Stock not committed 庫存尚未鎖定，無法處理訂單",
          });
          return;
        }

        if (response.data.tracking.orders[i].fulfilment_status == "fulfiled") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Fulfilment already completed 已完成出貨",
          });
          return;
        }

        if (response.data.tracking.orders[i].order_import_status == "hold") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "HOLD order 正在暫停處理",
          });
          return;
        }
      }

      this.disable_form = false;

      this.tracking_obj = response.data.tracking;
      this.product_serial = response.data.product_serial;
      this.order_master = this.tracking_obj.orders[0];

      if (this.tracking_obj.courier_short_name == 'HKTVMALL') {
        this.lockCtns = true;
      } else {
        this.lockCtns = false;
      }

      // console.log(this.tracking_obj);
      // console.log(this.order_master);
    },

    async getOrderMasterDetail() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_get.php",
        data: {
          tracking_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });
      if (response.data.orders && response.data.orders.length > 0) {
        let tmp_order_obj = response.data.orders[0];
        if (
          !tmp_order_obj.tracking_obj ||
          tmp_order_obj.tracking_obj.tracking_number == ""
        ) {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Invalid Tracking Number",
          });
          return;
        }

        if (tmp_order_obj.stock_status != "committed") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Stock not committed",
          });
          return;
        }

        if (tmp_order_obj.fulfilment_status == "completed") {
          this.$eventHub.$emit("show_modal_message", {
            message_content: "Fulfilment already completed",
          });
          return;
        }

        this.order_master = response.data.orders[0];
      }
    },

    async getOrderMasterProduct() {
      // let response = await this.$http({
      //   method: "POST",
      //   baseURL: `${this.API_HOST}`,
      //   url: "order_master_product_get.php",
      //   data: {
      //     order_number: this.order_master.order_number,
      //     account_type: this.$store.state.user_obj.account_type,
      //     client_id: this.$store.state.user_obj.client_id
      //   }
      // });

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "tracking_product_get.php",
        data: {
          tracking_number: this.order_master_search.order_number,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      let total_weight = 0;
      let total_item_qty = 0;
      for (let i in response.data.products) {
        if (response.data.products[i].stock_status == "cancel") {
          continue;
        }
        total_weight +=
          parseFloat(response.data.products[i].actual_weight_kg) *
          parseInt(response.data.products[i].product_qty);
        total_item_qty += parseInt(response.data.products[i].product_qty);
      }

      this.fulfil_obj.total_weight = total_weight;
      this.fulfil_obj.total_item_qty = total_item_qty;
      this.order_master_products = response.data.products;
    },

    async getProduct(row_product, row_product_i) {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "product_master_get.php",
        data: {
          product_sku: row_product.product_sku,
          account_type: this.$store.state.user_obj.account_type,
          client_id: this.$store.state.user_obj.client_id,
        },
      });

      if (response.data.products && response.data.products.length > 0) {
        this.fulfil_products[row_product_i].product_description =
          response.data.products[0]["product_description_en"];
        this.fulfil_products[row_product_i].product_qty = null;
      } else {
        this.fulfil_products[row_product_i].product_description = null;
        this.fulfil_products[row_product_i].product_qty = null;
      }
    },

    async searchOrder() {
      // if (this.$store.state.user_obj.client_id == "50") {
      //   this.order_master_search.order_number = 'NEO-'+this.order_master_search.order_number;
      // }
      // await this.getOrderMasterDetail();
      await this.getFulfilmentProcessInfo();
      await this.getOrderMasterProduct();

      // focus first row
      let next_ele_ref = "txt_product_sku_0";
      if (this.fulfil_obj.packed_by_vendor) {
        next_ele_ref = "txt_order_number_0";
      }
      this.$refs[next_ele_ref][0].$el.focus();
    },

    showModal_confirmFulfill(item) {
      this.$refs.modal_confirmFulfill.show();
    },

    hideModal_confirmFulfill() {
      this.$refs.modal_confirmFulfill.hide();
    },

    async validateRowInfo(row_product, row_product_i) {
      console.log("validate row info");
      if (this.fulfil_obj.packed_by_vendor) {
        // if (this.$store.state.user_obj.client_id == "50") {
        //   this.fulfil_orders[row_product_i].order_number = "NEO-"+this.fulfil_orders[row_product_i].order_number;
        // }
        this.lookupOrder(row_product, row_product_i);
      } else {
        if (
          this.fulfil_products[row_product_i].product_sku == null ||
          this.fulfil_products[row_product_i].product_sku == ""
          //   this.fulfil_products[row_product_i].inputType !== 'Barcode' && !this.fulfil_products[row_product_i].photo
        ) {
          return;
        }
        this.fulfil_products[row_product_i].product_sku =
          this.fulfil_products[row_product_i].product_sku.trim();
        if (!isNaN(this.fulfil_products[row_product_i].product_sku)) {
          // this.fulfil_products[row_product_i].product_sku = parseInt(this.fulfil_products[row_product_i].product_sku);
          this.fulfil_products[row_product_i].product_sku =
            this.fulfil_products[row_product_i].product_sku.replace(/^0+/, "");
        }

        this.lookupProduct(row_product, row_product_i);
      }
    },
    async lookupOrder(row_order, row_order_i) {
      // see if already exist first
      for (let i in this.fulfil_orders) {
        if (
          row_order_i != i &&
          this.fulfil_orders[row_order_i].order_number ==
          this.fulfil_orders[i].order_number
        ) {
          // cancel current input
          this.fulfil_orders[row_order_i].order_number = null;

          this.fulfil_orders = JSON.parse(JSON.stringify(this.fulfil_orders));

          return;
        }
      }

      // add new row if last
      if (row_order_i == this.fulfil_orders.length - 1) {
        this.fulfil_orders.push({
          order_cartons: 1,
        });
      }

      // focus next row
      let next_ele_ref = "txt_order_number_" + (row_order_i + 1);
      next_ele_ref = "txt_actual_total_weight";
      // this.$refs[next_ele_ref][0].$el.focus();
      setTimeout(() => {
        this.$refs[next_ele_ref].$el.focus();
      }, 200);
    },
    async _lookupProduct(row_product, row_product_i) {
      console.log("lookup product");
      // see if already exist first
      let product_not_found = true;

      for (let i in this.fulfil_products) {
        if (
          row_product_i != i &&
          this.fulfil_products[row_product_i].product_sku ==
          this.fulfil_products[i].product_sku
        ) {
          // check input mode
          if (this.fulfil_obj.remark_input_mode != '1') {
            this.fulfil_products[i].product_qty++;

            // cancel current input
            this.fulfil_products[row_product_i].product_sku = null;

            this.fulfil_products = JSON.parse(
              JSON.stringify(this.fulfil_products)
            );
            this.checkProductCnt();

            return;
          }
        }
      }

      // lookup in product array

      for (let i in this.order_master_products) {
        let order_master_product = this.order_master_products[i];
        if (
          order_master_product.product_sku ==
          this.fulfil_products[row_product_i].product_sku
        ) {
          this.fulfil_products[row_product_i].product_description =
            order_master_product.product_description;
          this.fulfil_products[row_product_i].product_qty = 1;
          this.fulfil_products[row_product_i].primary_category = order_master_product.primary_category;
          this.fulfil_products[row_product_i].product_remark = '';
          this.fulfil_products[row_product_i].commit_records = order_master_product.commit_records;
          product_not_found = false;
          break;
        } else {
          // NOT FOUND, Reject IT
          // this.fulfil_products[row_product_i].product_sku = null;
          // this.fulfil_products[row_product_i].product_qty = null;
          // this.fulfil_products[row_product_i].product_description = null;
          // this.$eventHub.$emit("show_modal_message", {
          //   message_content: "Invalid Product SKU"
          // });
          // NOT FOUND, still get product info
          // await this.getProduct(row_product, row_product_i);
          // this.fulfil_products[row_product_i].product_description = null;
          // this.fulfil_products[row_product_i].product_qty = null;
        }
      }

      if (product_not_found) {
        this.fulfil_products[row_product_i].product_sku = null;
        this.fulfil_products[row_product_i].product_qty = null;
        this.fulfil_products[row_product_i].product_description = null;
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Product SKU",
        });
      }

      this.fulfil_products = JSON.parse(JSON.stringify(this.fulfil_products));

      this.checkProductCnt();

      // add new row if last
      // console.log(row_product_i);
      // console.log(this.fulfil_products.length);
      if (row_product_i == this.fulfil_products.length - 1) {
        this.fulfil_products.push({});
      }

      // focus next row
      // let next_ele_ref =
      //   "txt_product_sku_" +
      //   ((row_product_i + 1) % this.fulfil_products.length-1);
      let next_ele_ref = "txt_product_sku_" + (row_product_i + 1);
      setTimeout(() => {
        if (this.fulfil_obj.remark_input_mode == '1') {
          // focus remark if it is voucher
          if (this.fulfil_products[row_product_i].primary_category == 'Voucher') {
            next_ele_ref = "txt_remark_" + (row_product_i);
            this.$refs[next_ele_ref][0].$el.focus();
          } else {
            this.$refs[next_ele_ref][0].$el.focus();
          }

        } else {
          this.$refs[next_ele_ref][0].$el.focus();
        }
      }, 200);
    },

    checkProductCnt() {
      let total_cnt = 0;
      let total_weight = 0;
      for (let i in this.fulfil_products) {
        let fulfil_product = this.fulfil_products[i];
        if (fulfil_product.product_description != null) {
          total_cnt += parseInt(fulfil_product.product_qty);
        }
      }

      this.fulfil_obj.actual_total_item_qty = total_cnt;
      this.fulfil_obj = JSON.parse(JSON.stringify(this.fulfil_obj));
      console.log(this.fulfil_obj.actual_total_item_qty);
    },

    async updateFulfillStatus() {
      let order_master_ids = [];
      for (let i in this.tracking_obj.orders) {
        order_master_ids.push(this.tracking_obj.orders[i].id);
      }

      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil.php",
        data: {
          order_master_ids: order_master_ids,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          total_weight: this.fulfil_obj.actual_total_weight,
          total_height_cm: this.fulfil_obj.actual_size_height,
          total_width_cm: this.fulfil_obj.actual_size_width,
          total_depth_cm: this.fulfil_obj.actual_size_depth,
          packed_by_vendor: this.fulfil_obj.packed_by_vendor,
          total_ctns: this.fulfil_obj.no_of_cartons,
          fulfil_orders: this.fulfil_orders,
          remark_input_mode: this.fulfil_obj.remark_input_mode,
          fulfil_products: this.fulfil_products
        },
      });

      if (!response.data || response.data.status !== "success") {
        return response;
      }

      if (response.data && response.data.shopify_upload_id) {
        // await this.updateShopifyFulfilmentStatus(
        //   response.data.shopify_upload_id
        // );
      }

      this.disable_form = true;

      // await this.getOrderMasterDetail();

      let response_record = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "order_master_fulfil_record.php",
        data: {
          tracking_number: this.tracking_obj.tracking_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          fulfil_products: this.fulfil_products,
        },
      });

      return response;
    },

    checkTotalWeight() {
      let is_valid_weight = false;

      // bypass
      if (this.tracking_obj.fulfil_weight_optional == 1) {
        return true;
      }
      let weight_diff =
        this.fulfil_obj.total_weight - this.fulfil_obj.actual_total_weight;

      // console.log(this.fulfil_obj.total_weight);
      // console.log(this.fulfil_obj.actual_total_weight);
      // console.log(weight_diff);

      let weight_overhead = 0.5;
      if (this.$store.state.user_obj.client_id == 1) {
        weight_overhead = 0.3;
        // if (
        //   this.fulfil_obj.actual_total_weight > 0
        // ) {
        //   is_valid_weight = true;
        // }
        if (
          this.fulfil_obj.actual_total_weight > 0 &&
          weight_diff < weight_overhead &&
          weight_diff > weight_overhead * -1
        ) {
          is_valid_weight = true;
        }
      } else {
        if (
          this.fulfil_obj.actual_total_weight > 0 &&
          weight_diff < weight_overhead &&
          weight_diff > weight_overhead * -1
        ) {
          is_valid_weight = true;
        }
      }

      return is_valid_weight;
    },

    checkTotalCtns() {
      let is_valid_ctns = true;

      if (
        !Number.isInteger(parseInt(this.fulfil_obj.no_of_cartons)) ||
        this.fulfil_obj.no_of_cartons <= 0 ||
        this.fulfil_obj.no_of_cartons > 999
      ) {
        is_valid_ctns = false;
      }

      return is_valid_ctns;
    },

    checkAllRemark() {
      let is_valid = true;
      console.log(this.fulfil_products);

      if (this.fulfil_obj.remark_input_mode == '1') {
        for (let i in this.fulfil_products) {
          if (!this.fulfil_products[i].remark_ok) {
            is_valid = false;
          }
          // if(this.fulfil_products[i].primary_category == 'Voucher'){
          //   if(this.fulfil_products[i].product_remark == ''){
          //     return false;
          //   }else{
          //     // check if duplicates local
          //     for (let i in this.fulfil_products) {
          //       // sku & remark same
          //       if(this.fulfil_products[i].product_sku == product_obj.product_sku){
          //         if(this.fulfil_products[i].product_remark == product_obj.product_remark){
          //           return true;
          //         }
          //       }
          //     }
          //   }
          // }
        }
      }

      return is_valid;
    },

    checkRemarkDuplicates(product_obj) {

      return false;
    },

    checkProductRowSKUState(row_product) {
      if (row_product.product_sku == null) {
        return null;
      } else {
        return (
          row_product.product_description != null &&
          row_product.product_qty != null
        );
      }
    },

    checkOrderRowState(row_order, row_order_i) {
      if (row_order.order_number == null) {
        return null;
      }
      let is_valid = false;
      // lookup in order array
      for (let i in this.tracking_obj.orders) {
        let order_master_order = this.tracking_obj.orders[i];
        if (
          order_master_order.order_number ==
          this.fulfil_orders[row_order_i].order_number
        ) {
          is_valid = true;
          break;
        }
      }
      return is_valid;
    },

    checkProductRowQtyState(row_product, row_product_i) {
      if (row_product.product_sku == null || row_product.product_sku == "") {
        return null;
      } else {
        // lookup in product array
        for (let i in this.order_master_products) {
          let order_master_product = this.order_master_products[i];
          if (
            order_master_product.product_sku ==
            this.fulfil_products[row_product_i].product_sku
          ) {
            // remark input mode always 1
            if (this.fulfil_obj.remark_input_mode == '1') {
              return true;
            } else if (
              // check if qty exact match
              this.fulfil_products[row_product_i].product_qty ==
              order_master_product.product_qty
            ) {
              return true;
            }
            break;
          }
        }

        // qty not found/match
        return false;
      }
    },

    checkProductRowRemarkState(row_product, row_product_i) {
      console.log(row_product);
      if (row_product.product_sku == null || row_product.product_sku == "") {
        this.fulfil_products[row_product_i].remark_ok = true;
        return null;
      } else {
        // if primary cate = evoucher, return false if remark empty
        if (row_product.primary_category == 'Voucher') {
          if (row_product.product_remark == '') {
            this.fulfil_products[row_product_i].remark_ok = false;
            return false;
          } else {
            // check if duplicates local
            for (let i in this.fulfil_products) {
              // not same row
              if (row_product_i != i) {
                // sku & remark same
                if (this.fulfil_products[i].product_sku == row_product.product_sku) {
                  if (this.fulfil_products[i].product_remark == row_product.product_remark) {
                    this.fulfil_products[row_product_i].remark_ok = false;
                    return false;
                  }
                }
              }
            }

            // check if duplicates remote
            // **NEW CHECK: Skip remote check if product_serial is empty**
            if (this.product_serial.length > 0) {
              if (this.product_serial.indexOf(row_product.product_sku + "_" + row_product.product_remark) == -1) {
                this.fulfil_products[row_product_i].remark_ok = false;
                return false;
              }
            }
          }
        }
        this.fulfil_products[row_product_i].remark_ok = true;
        return true;
      }
    },

    unlockQtyInput(row_product, row_product_i) {
      // if(this.fulfil_obj.remark_input_mode != '1'){
      //   this.fulfil_products[row_product_i].unlock_qty = true;
      // }
    },

    canPrintWaybill() {
      if (this.disable_form) {
        return true;
      }
      if (this.fulfil_obj.packed_by_vendor) {
        return false;
        // if(!this.tracking_obj){
        //   return false;
        // }
        // return (this.fulfil_orders.length == this.tracking_obj.orders.length);
      } else {
        return !(
          this.isItemCountValid() &&
          this.checkTotalWeight() &&
          this.checkTotalCtns() &&
          this.checkAllRemark()
        );
      }
    },

    async updateShopifyFulfilmentStatus(shopify_upload_id) {
      let checked_items = [];

      checked_items.push(shopify_upload_id);

      this.$http({
        url: this.NODEJS_API_URL + "/shopify_order_update",
        method: "POST",
        data: {
          ids: checked_items,
          notify_customer: "yes",
        },
      }).then((response) => { });
    },

    async printWaybill() {
      this.loader = this.$loading.show({
        isFullPage: true,
        canCancel: false,
      });
      let fulfilment_response = await this.updateFulfillStatus();
      if (!fulfilment_response || !fulfilment_response.data.status || fulfilment_response.data.status != 'success') {
        console.log("error");
        this.$eventHub.$emit("show_modal_message", {
          message_content:
            (fulfilment_response && fulfilment_response.data && (fulfilment_response.data.message || fulfilment_response.data.error)) ||
            "Fulfilment Failed",
        });
        this.loader.hide();
        return;
      }

      // let tracking_number = this.order_master.tracking_obj.tracking_number;
      let tracking_number = this.tracking_obj.tracking_number;

      let pdf_type = "";
      if (
        this.tracking_obj.courier_short_name.toLowerCase() == "gols" ||
        this.tracking_obj.courier_short_name.toLowerCase() == "whole"
      ) {
        let checked_items = [];
        checked_items.push(tracking_number);

        let no_of_waybill = 1;
        if (
          this.fulfil_obj.no_of_cartons &&
          this.fulfil_obj.no_of_cartons != 0
        ) {
          no_of_waybill = this.fulfil_obj.no_of_cartons;
        }

        let self = this;
        this.$http({
          url: process.env.NODEJS_API_URL_PDF + "/gen_pdf",
          method: "POST",
          data: {
            ids: checked_items,
            print_packing: false,
            print_waybill: true,
            no_of_waybill: no_of_waybill,
            print_as_file: 1,
            user_id: this.$store.state.user_obj.user_id,
          },
        }).then((response) => {
          setTimeout(() => {
            self.pdf_to_print =
              process.env.NODEJS_PDF_URL + "/" + tracking_number + ".pdf";
          }, 1000);

          setTimeout(() => {
            let objFra = document.getElementById("myFrame-fulfil");
            objFra.contentWindow.focus();
            objFra.contentWindow.print();
          }, 4000);

          setTimeout(() => {
            self.loader.hide();
            self.cleanupFormData();

            // fetch(self.pdf_to_print).then(function (t) {
            //   return t.blob().then((b) => {
            //     var a = document.createElement("a");
            //     a.href = URL.createObjectURL(b);
            //     a.setAttribute("download", self.pdf_to_print.split("/").pop());
            //     a.click();
            //   });
            // });
          }, 6000);
        });
      } else if (this.tracking_obj.courier_short_name.toLowerCase() == "7-11") {
        let checked_items = [];
        checked_items.push(tracking_number);

        let no_of_waybill = 1;
        if (
          this.fulfil_obj.no_of_cartons &&
          this.fulfil_obj.no_of_cartons != 0
        ) {
          no_of_waybill = this.fulfil_obj.no_of_cartons;
        }

        let self = this;
        this.$http({
          url: this.NODEJS_API_URL + "/redemption_waybill",
          method: "POST",
          data: {
            ids: checked_items,
            print_packing: false,
            print_waybill: true,
            no_of_waybill: no_of_waybill,
            print_as_file: 1,
          },
        }).then((response) => {
          self.pdf_to_print =
            process.env.NODEJS_PDF_URL + "/" + tracking_number + ".pdf";

          setTimeout(() => {
            let objFra = document.getElementById("myFrame-fulfil");
            objFra.contentWindow.focus();
            objFra.contentWindow.print();
          }, 4000);

          setTimeout(() => {
            self.loader.hide();
            self.cleanupFormData();

            // fetch(self.pdf_to_print).then(function (t) {
            //   return t.blob().then((b) => {
            //     var a = document.createElement("a");
            //     a.href = URL.createObjectURL(b);
            //     a.setAttribute("download", self.pdf_to_print.split("/").pop());
            //     a.click();
            //   });
            // });
          }, 6000);
        });
      } else if (
        this.tracking_obj.courier_short_name.toLowerCase() != "sf-cn"
      ) {
        let self = this;
        // let pdf_to_print_src =
        //   "https://tracking.gols.com.hk/waybill_file/" +
        //   this.tracking_obj.courier_short_name.toUpperCase() +
        //   "/" +
        //   this.tracking_obj.tracking_number +
        //   ".pdf";

        // this.pdf_to_print = "https://sys.gols.com.hk/api/download_ftp_waybill.php?url="+pdf_to_print_src;
        let pdf_to_print_src = encodeURIComponent(this.tracking_obj.courier_short_name.toUpperCase() +
          "/" +
          this.tracking_obj.tracking_number);
        this.pdf_to_print = "https://sys.gols.com.hk/api/download_ftp_waybill.php?url=" + pdf_to_print_src;

        setTimeout(() => {
          let objFra = document.getElementById("myFrame-fulfil");
          objFra.contentWindow.focus();
          objFra.contentWindow.print();
        }, 4000);

        setTimeout(() => {
          self.loader.hide();
          self.cleanupFormData();

          // fetch(self.pdf_to_print).then(function (t) {
          //   return t.blob().then((b) => {
          //     var a = document.createElement("a");
          //     a.href = URL.createObjectURL(b);
          //     a.setAttribute("download", tracking_number + ".pdf");
          //     // a.setAttribute("download", self.pdf_to_print.split("/").pop());
          //     a.click();
          //   });
          // });
        }, 6000);
      }

      let response = await this.$http({
          method: "POST",
          baseURL: `${this.API_HOST}`,
          url: "print_waybill_log.php",
          data: {
            tracking_number: this.tracking_obj.tracking_number,
            client_id: this.$store.state.user_obj.client_id,
            user_id: this.$store.state.user_obj.user_id,
          },
        });
    },

    cleanupFormData() {
      this.fulfil_products = [{}];
      this.order_master_search = {};

      let current_packed_by_vendor = this.fulfil_obj.packed_by_vendor;
      let current_remark_input_mode = this.fulfil_obj.remark_input_mode;

      // cleanup
      this.fulfil_obj = {
        total_item_qty: 0,
        total_weight: 0,
        actual_total_weight: 0,
        actual_total_item_qty: 0,
        actual_size_height: null,
        actual_size_width: null,
        actual_size_depth: null,
        no_of_cartons: 1,
        packed_by_vendor: current_packed_by_vendor,
        remark_input_mode: current_remark_input_mode,
      };
      this.fulfiled_remark = [];
      this.order_master = {};
      this.fulfil_orders = [
        {
          order_cartons: 1,
        },
      ];

      this.$refs["txt_order_number"].$el.focus();
    },
    isItemCountValid() {
      if (
        this.fulfil_obj.total_item_qty != this.fulfil_obj.actual_total_item_qty
      ) {
        return false;
      }

      let valid = true;

      if (this.fulfil_obj.remark_input_mode == '1') {
        // group product & qty for checking
        let tmp_fulfil_products = {};
        for (let tfpi in this.fulfil_products) {
          let tmp_fulfil_product = this.fulfil_products[tfpi];

          if (tmp_fulfil_products[tmp_fulfil_product.product_sku]) {
            tmp_fulfil_products[tmp_fulfil_product.product_sku]['product_qty'] += tmp_fulfil_product.product_qty;
          } else {
            tmp_fulfil_products[tmp_fulfil_product.product_sku] = {
              product_sku: tmp_fulfil_product.product_sku,
              product_qty: tmp_fulfil_product.product_qty
            };
          }
        }

        // turn obj into array
        let tmp_fulfil_products_array = [];
        for (let tfpi2 in tmp_fulfil_products) {
          tmp_fulfil_products_array.push(tmp_fulfil_products[tfpi2]);
        }

        for (const [key, value] of Object.entries(this.order_master_products)) {
          let fulfilled_product = tmp_fulfil_products_array.find(
            (p) => p.product_sku === key
          );
          let fulfilled_product_qty = fulfilled_product
            ? fulfilled_product.product_qty
            : -1;
          if (fulfilled_product_qty != value.committed_qty) {
            valid = false;
          }
        }

        return valid;
      } else {
        for (const [key, value] of Object.entries(this.order_master_products)) {
          let fulfilled_product = this.fulfil_products.find(
            (p) => p.product_sku === key
          );
          let fulfilled_product_qty = fulfilled_product
            ? fulfilled_product.product_qty
            : -1;
          if (fulfilled_product_qty != value.committed_qty) {
            valid = false;
          }
        }

        return valid;
      }
    },

    showModal_takePhoto(item) {
      this.$refs.modal_takePhoto.show();
    },

    hideModal_takePhoto() {
      this.$refs.modal_takePhoto.hide();
    },

    onCameras(cameras) {
      this.devices = cameras;
      console.log("On Cameras Event", cameras);
    },
    onCameraChange(deviceId) {
      this.deviceId = deviceId;
      this.camera = deviceId;
      console.log("On Camera Change Event", deviceId);
    },

    onOpenTakePhotoModal(row_index) {
      this.fulfil_product_index = row_index;
      let fulfil_product = this.fulfil_products[row_index];
      console.log(row_index, fulfil_product);
      if (fulfil_product.inputType == "Keyboard") {
        this.showModal_takePhoto(fulfil_product);
        console.log(this.$refs);
        // this.$refs.webcam.start();
      }
    },

    onTakePhoto() {
      this.updateFulfilProduct(
        this.fulfil_product_index,
        "photo",
        this.$refs.webcam.capture()
      );
      this.hideModal_takePhoto();
    },

    onCancelTakePhoto() {
      this.hideModal_takePhoto();
      this.$refs.webcam.stop();
    },

    onKeyDown(event, index) {
      console.log(event);
      if (event.key === "Enter") return;
      let product = this.fulfil_products[index];
      console.log(product);
      if (!product.timeout) {
        let prev_code = product.product_sku || "";
        console.log(prev_code);
        this.updateFulfilProduct(index, "prev_product_sku", prev_code);
        this.updateFulfilProduct(
          index,
          "timeout",
          setTimeout(() => {
            let diff = product.product_sku.length - prev_code.length;

            if (diff >= 8) {
              this.updateFulfilProduct(index, "inputType", "Barcode");
            } else {
              this.updateFulfilProduct(index, "inputType", "Keyboard");
            }
            clearTimeout(this.fulfil_products[index].timeout);
            this.updateFulfilProduct(index, "timeout", null);
          }, 100)
        );
      }
    },

    // onKeyDownRemark(row_product, index) {

    //   let next_ele_ref = "txt_product_sku_" + (index + 1);
    //   setTimeout(() => {
    //     this.$refs[next_ele_ref][0].$el.focus();
    //   }, 200);
    // },

    updateFulfilProduct(index, key, value) {
      let tmp = this.fulfil_products;
      tmp[index][key] = value;
      this.fulfil_products = [...tmp];
    },

    showModal_showRemainingItems() {
      this.$refs.modal_showRemainingItems.show();
    },

    hideModal_showRemainingItems() {
      this.$refs.modal_showRemainingItems.hide();
    },

    maskSku(sku) {
      const value = String(sku || "").trim();
      if (!value) return "-";
      if (value.length <= 8) return value;
      return `${value.slice(0, 4)}*****${value.slice(-4)}`;
    },

    showRemainingItems() {
      const fulfilledQtyBySku = {};
      this.not_fulfiled_items = [];

      for (let i in this.fulfil_products) {
        const item = this.fulfil_products[i];
        if (!item || !item.product_sku || !item.product_qty) continue;

        const sku = String(item.product_sku).trim();
        const qty = parseInt(item.product_qty, 10) || 0;

        if (!fulfilledQtyBySku[sku]) {
          fulfilledQtyBySku[sku] = 0;
        }
        fulfilledQtyBySku[sku] += qty;
      }

      for (let i in this.order_master_products) {
        const orderItem = this.order_master_products[i];
        const sku = String(orderItem.product_sku || "").trim();
        const committedQty = parseInt(
          orderItem.committed_qty != null
            ? orderItem.committed_qty
            : orderItem.product_qty,
          10
        ) || 0;
        const fulfilledQty = fulfilledQtyBySku[sku] || 0;
        const remainingQty = committedQty - fulfilledQty;

        if (remainingQty > 0) {
          this.not_fulfiled_items.push({
            ...orderItem,
            remaining_qty: remainingQty,
          });
        }
      }

      this.showModal_showRemainingItems();
    },

    disablePause() {
      let is_disble_pause = true;
      if (this.fulfil_obj && this.fulfil_obj.actual_total_item_qty > 0) {
        is_disble_pause = false;
      }
      return is_disble_pause;
    },

    async pauseFulfilment() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "fulfilment_product_encrypt.php",
        data: {
          tracking_number: this.order_master_search.order_number,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
          fulfil_products: this.fulfil_products,
        },
      });

      if (response.data && response.data.token) {
        this.$http({
          url: this.NODEJS_API_URL + "/print_pause_fulfilment",
          method: "POST",
          data: {
            tracking_number: response.data.tracking_number,
            token: response.data.token,
            item_count: this.fulfil_obj.actual_total_item_qty,
            client_name: this.tracking_obj.client_name,
            courier_short_name: this.tracking_obj.courier_short_name,
          },
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", this.order_master_search.order_number + "_PAUSE.pdf");
          document.body.appendChild(link);
          link.click();
        });
      }
    },

    focusRef(refName) {
      this.$nextTick(() => {
        const ref = this.$refs[refName];
        if (!ref) return;

        const target = Array.isArray(ref) ? ref[0] : ref;

        if (target && target.$el && typeof target.$el.focus === "function") {
          target.$el.focus();
        } else if (target && typeof target.focus === "function") {
          target.focus();
        }
      });
    },

    focusNextEmptyProductSku(currentIndex = -1) {
      let nextIndex = -1;

      // 先由 currentIndex 之後開始搵
      for (let i = currentIndex + 1; i < this.fulfil_products.length; i++) {
        const sku = String((this.fulfil_products[i] && this.fulfil_products[i].product_sku) || "").trim();
        if (!sku) {
          nextIndex = i;
          break;
        }
      }

      // 如果下面冇空，再由頭搵到 currentIndex
      if (nextIndex === -1) {
        for (let i = 0; i <= currentIndex; i++) {
          const sku = String((this.fulfil_products[i] && this.fulfil_products[i].product_sku) || "").trim();
          if (!sku) {
            nextIndex = i;
            break;
          }
        }
      }

      // 如果成張表都冇空白，加新 row
      if (nextIndex === -1) {
        this.fulfil_products.push({});
        this.fulfil_products = JSON.parse(JSON.stringify(this.fulfil_products));
        nextIndex = this.fulfil_products.length - 1;
      }

      this.focusRef("txt_product_sku_" + nextIndex);
    },

    async lookupProduct(row_product, row_product_i) {
      console.log("lookup product");
      let product_not_found = true;

      for (let i in this.fulfil_products) {
        if (
          row_product_i != i &&
          this.fulfil_products[row_product_i].product_sku ==
          this.fulfil_products[i].product_sku
        ) {
          if (this.fulfil_obj.remark_input_mode != "1") {
            this.fulfil_products[i].product_qty++;

            // cancel current input
            this.fulfil_products[row_product_i].product_sku = null;

            this.fulfil_products = JSON.parse(JSON.stringify(this.fulfil_products));
            this.checkProductCnt();

            // duplicate scan 後，focus 返當前清空咗嘅 textbox
            this.focusRef("txt_product_sku_" + row_product_i);
            return;
          }
        }
      }

      for (let i in this.order_master_products) {
        let order_master_product = this.order_master_products[i];
        if (
          order_master_product.product_sku ==
          this.fulfil_products[row_product_i].product_sku
        ) {
          this.fulfil_products[row_product_i].product_description =
            order_master_product.product_description;
          this.fulfil_products[row_product_i].product_qty = 1;
          this.fulfil_products[row_product_i].primary_category =
            order_master_product.primary_category;
          this.fulfil_products[row_product_i].product_remark = "";
          this.fulfil_products[row_product_i].commit_records =
            order_master_product.commit_records;
          product_not_found = false;
          break;
        }
      }

      if (product_not_found) {
        this.fulfil_products[row_product_i].product_sku = null;
        this.fulfil_products[row_product_i].product_qty = null;
        this.fulfil_products[row_product_i].product_description = null;
        this.$eventHub.$emit("show_modal_message", {
          message_content: "Invalid Product SKU",
        });

        this.fulfil_products = JSON.parse(JSON.stringify(this.fulfil_products));
        this.focusRef("txt_product_sku_" + row_product_i);
        return;
      }

      this.fulfil_products = JSON.parse(JSON.stringify(this.fulfil_products));
      this.checkProductCnt();

      // 保持最後一行永遠有空白 row
      const hasEmptyRow = this.fulfil_products.some(
        (item) => !String((item && item.product_sku) || "").trim()
      );
      if (!hasEmptyRow) {
        this.fulfil_products.push({});
        this.fulfil_products = JSON.parse(JSON.stringify(this.fulfil_products));
      }

      // remark mode + Voucher => 先去 remark
      if (
        this.fulfil_obj.remark_input_mode == "1" &&
        this.fulfil_products[row_product_i].primary_category == "Voucher"
      ) {
        this.focusRef("txt_remark_" + row_product_i);
      } else {
        // 其他情況 => 跳去下一個空白 SKU textbox
        this.focusNextEmptyProductSku(row_product_i);
      }
    },

    onKeyDownRemark(row_product, index) {
      this.focusNextEmptyProductSku(index);
    },
  }
};
</script>

<style>
th,
td {
  white-space: nowrap;
}

.dev_test {
  flex: 1;
}

.valid_lot {
  color: #28a745
}

.div-commit_lot-container {
  min-height: calc(1.5em + 0.5rem + 2px);
  background-color: #e9ecef;
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  border: 1px solid #ced4da;
}

.remaining-items-modal .modal-dialog {
  max-width: 720px;
}

.remaining-items-modal-content {
  border-radius: 14px;
  overflow: hidden;
}

.remaining-items-wrapper {
  padding: 4px 2px;
}

.remaining-items-header {
  padding-bottom: 12px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e9ecef;
}

.remaining-items-title {
  font-size: 20px;
  font-weight: 700;
  color: #212529;
}

.remaining-items-subtitle {
  font-size: 13px;
  color: #6c757d;
  margin-top: 4px;
}

.remaining-items-list {
  max-height: 420px;
  overflow-y: auto;
  padding-right: 4px;
}

.remaining-item-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  border: 1px solid #e9ecef;
  border-radius: 12px;
  padding: 12px 14px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.remaining-item-card+.remaining-item-card {
  margin-top: 10px;
}

.remaining-item-left {
  flex: 1;
  min-width: 0;
}

.remaining-item-index {
  font-size: 12px;
  font-weight: 700;
  color: #6c757d;
  margin-bottom: 4px;
}

.remaining-item-desc {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
  word-break: break-word;
}

.remaining-item-sku {
  font-size: 18px;
  font-weight: 700;
  color: #212529;
  margin-top: 8px;
  letter-spacing: 0.5px;
  line-height: 1.25;
  word-break: break-word;
}

.remaining-item-right {
  min-width: 92px;
  text-align: right;
}

.remaining-item-qty-label {
  font-size: 11px;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  margin-bottom: 4px;
}

.remaining-item-qty {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  color: #dc3545;
}

.remaining-items-empty {
  text-align: center;
  padding: 28px 12px;
  border: 1px dashed #ced4da;
  border-radius: 12px;
  background: #f8f9fa;
}

.remaining-items-empty-title {
  font-size: 18px;
  font-weight: 600;
  color: #28a745;
}

.remaining-items-empty-subtitle {
  font-size: 13px;
  color: #6c757d;
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/FulfillmentProcessV2.vue